<template>
  <div>
    <div class="lifestyle-pricelist-images" v-if="!isModalLoading">
      <div v-if="images.length > 0" class="images-wrapper">
        <grid-card :min="100" :column="'4'" :gap="10" v>
          <template slot="item">
            <img
              v-for="(image, index) in images"
              :key="index"
              class="img-rounded"
              :src="image.thumb"
              alt
              @click="photosPreview(image.thumb, index)"
            />
          </template>
        </grid-card>
      </div>
      <div v-else>
        <adx-empty-selection :subtitle="subtitle"/>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";

import GridCard from "@/components/Grid/Card";
import EmptySelection from "@/components/NotFound/Selection";

import _ from "lodash";

export default {
  name: "adx-lifestyle-placement-images",
  components: {
    "a-loading": ALoadingPrimary,
    "grid-card": GridCard,
    "adx-empty-selection": EmptySelection
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      bottomPrice: null,
      quantity: null,
      minQuantity: null,
      description: null,
      minPeriod: null,
      minPeriodPlan: null,
      images: [],
      subtitle: ' '
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.lifestylePricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );
      if (status === 200) {
        data.items.map(item =>{
          item.contents.map(content =>{
            this.images.push(content)
          })
        })
      }
      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    },
    photosPreview(src, index) {
      window.open(src, "_blank");
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>

<style lang="scss">
.lifestyle-pricelist-images {
  .gridCard {
    margin-right: 8px;
  }
}
</style>